<div class="container">
  <h1 class="title">{{'locker.discount.title'|traduccion}}</h1>

  <button mat-raised-button color="primary" (click)="openNewDiscount()"><mat-icon>add</mat-icon></button>

  <!-- Tabla de resultados -->
  <div class="table-container">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [rowClickable]="true"
      [rowClass]="discountRowClass"
      tableClass="mat-elevation-z1"
      (rowClick)="openDetails($event.row)">


      <!-- code -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>{{'locker.discount.table.header.code'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.code }}</td>
      </ng-container>

      <!-- description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{'locker.discount.table.header.description'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>

      <!-- discount -->
      <ng-container matColumnDef="discount">
        <th mat-header-cell *matHeaderCellDef> {{'locker.discount.table.header.discount'|traduccion}} </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.discountType=='AMOUNT'">{{ element.discount|currency }}</span>
          <span *ngIf="element.discountType=='PERCENTAGE'">{{ element.discount|currency:'%' }}</span>
        </td>
      </ng-container>

      <!-- productIds -->
      <ng-container matColumnDef="productIds">
        <th mat-header-cell *matHeaderCellDef> {{'locker.discount.table.header.productIds'|traduccion}} </th>
        <td mat-cell *matCellDef="let element"> {{ descriptionProduct(element.productIds) }} </td>
      </ng-container>

       <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
        [ngClass]="{'disabled': !row.enabled}">
      </tr>

    </app-data-table>
  </div>
</div>
